import "./style/index.scss";
import { useEffect, useState } from "react";
import Spinner from "../../util/assets/spinner.svg?react";
import { Flex, Space } from "antd";

const Loading = () => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((r) => r + 30);
    }, 75);
    return () => clearInterval(interval);
  }, [75]);

  return (
    <Space direction="vertical">
      <Flex vertical gap={10} justify="center" align="center" className="flex_spinner">
        <Spinner
          style={{
            transform: `rotate(${rotation}deg)`,
            fill: "blue",
            width: "75px",
            height: "75px",
          }}
        />
      </Flex>
    </Space>
  );
};

export default Loading;
